import ContextMenuWrapper from "./LogicalWrapper/ContextMenuWrapper";

const ContextMenuBuildFrame = () => {
    return (
        <ContextMenuWrapper>
            {
                // todo in the future: implement the context menu for the build frame
                // meanwhile added it to disable the right click
            }
        </ContextMenuWrapper>
    );
};

export default ContextMenuBuildFrame;
